'use strict';

var $ = require('jquery');

/**
 * Sends JQuery events when RichFaces / A4J does an ajax request
 * 
 * The events are triggered on document because according to https://api.jquery.com/Ajax_Events/
 * that is what jQuery does: "These events are triggered on the document"
 * 
 * Watch with code like this: $(document).on('a4jComplete', function(event, a4j) { ... });
 * The a4j param is an object containing the parameters that a4j sends.
 * 
 */
if (typeof A4J !== 'undefined' && A4J.AJAX) {
	var listeners = {
		queueonsubmit: function(request) {
			$(document).triggerHandler('a4jSubmit', {request: request});
		},
		queueoncomplete: function(request, event, data) {
			$(document).triggerHandler('a4jComplete', {request: request, event: event, data: data});
		},
		queueonerror: function(request, status, message) {
			$(document).triggerHandler('a4jError', {request: request, status: status, message: message});
		}
	};
	A4J.AJAX.EventQueue.addQueue(new A4J.AJAX.EventQueue('org.richfaces.queue.global', null, listeners));
}